export default __webpack_public_path__ + "static/media/logo.693b5eae.svg";